import { Component, OnInit, ViewChild } from '@angular/core';
import { GridOptions, GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { AssignDialogComponent } from 'src/app/common/assign-dialog/assign-dialog.component';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { RouteComponent } from 'src/app/common/route/route.component';
import { IstDataShareService } from 'src/app/services/ist/ist-datashare.service';
import { DateObject, IST_APP, ModuleMenu } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { HeadService } from 'src/app/services/common/headservice';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ist-applications',
  templateUrl: './ist-applications.component.html',
  styleUrls: ['./ist-applications.component.scss']
})
export class IstApplicationsComponent implements OnInit {
  //@ViewChild("header") header: HeaderComponent;

  gridApi: GridApi;
  columnDefs: any[];
  collapesedOrNot:any
  operations: any[];
  tempoperations: any[];
  rowData;
  advanceSearch: any;
  selectedRow;
  caseDetails;
  studyType: any[];
  requestType: any[];
  StatusList: any;
  TherapeuticAreaList:any[];
  productList:any[];
  istapp: IST_APP;
  menudata: ModuleMenu;
  IStApplicationsSearch: UntypedFormGroup;
  isProduct:boolean=false;
  isHadPermission:boolean = false;
  maxDate = new Date() ; 
  myDate = new Date();  
  yesterday = new Date(this.myDate.setDate(new Date().getDate()+1));
  year = this.yesterday.getFullYear();
  moth = this.yesterday.getMonth() + 1;
  Day = this.yesterday.getDate();
  
  //SDates:any;
  //EDates:any;

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private dataShare: IstDataShareService,
    private commonService: CommonService,
    private header: HeadService
  ) {

  }

  ngOnInit() {

    //this.requestType= [{ "value": "", "label": "All" }, { "value": "1", "label": "Funds" }, { "value": "2", "label": "Product" }, { "value": "3", "label": "Both" }];
    //this.StatusList= [{ "value": "", "label": "All" },{ "value": "1", "label": "Draft" }, { "value": "2", "label": "Submitted" }, { "value": "3", "label": "Review Ongoing" }, { "value": "4", "label": "Accepted" }, { "value": "5", "label": "Closed" }, { "value": "6", "label": "Rejected" }, { "value": "7", "label": "On-hold" }, { "value": "8", "label": "Withdrawn" }, { "value": "9", "label": "Discarded" }];

    this.IStApplicationsSearch = new UntypedFormGroup({
      Title: new UntypedFormControl(""),
      PhysicianName: new UntypedFormControl(""),
      TherapeuticArea: new UntypedFormControl(""),
      RequestType: new UntypedFormControl(""),
      Product: new UntypedFormControl(""),
      StudyType: new UntypedFormControl(""),
      Assignedto: new UntypedFormControl(""),
      Status: new UntypedFormControl(""),
      StartDate:new UntypedFormControl(null),
      EndDate: new UntypedFormControl(null),     
    });
       
    this.columnDefs= [
      {
        "headerName": "Application ID",
        "field": "APPLICATION_CODE"
      },
      {
        "headerName": "Application Type",
        "field": "APPLICATION_TYPE"
      },
      {
        "headerName": "Physician Name",
        "field": "PhysicianName"
      },
      {
        "headerName": "Therapeutic Area",
        "field": "THERAPEUTIC_AREA_NAME"
      },
      {
        "headerName": "Request Type",
        "field": "REQUEST_TYPE_NAME"
      },
      {
        "headerName": "Product",
        "field": "PRODUCT_NAME"
      },
      {
        "headerName": "Study Type",
        "field": "StudyType"
      },
      {
        "headerName": "Status",
        "field": "STATUSStr"
      },
      {
        "headerName": "Submitted On",
        "field": "SubmittedOnStr"
      },
      {
        "headerName": "Owner",
        "field": "AssignedTo"
      },
      {
        "headerName": "Last Updated On",
        "field": "LastUpdatedStr"
      }
    ];
    let chnageWonership = this.commonService.getScreenPermission("201","C");
     let hadeditPermission = this.commonService.getScreenPermission("201","E");
     if(chnageWonership || hadeditPermission)
     {
       this.isHadPermission=true;
     }
    this.advanceSearch ={
      "fields": [
        {
          "label": "Title",
          "field": "title",
          "type": "text"
        },
        {
          "label": "Physician Name",
          "field": "PhysicianName",
          "type": "text"
        },
        {
          "label": "Therapeutic Area",
          "field": "TherapeuticArea",
          "type": "dropdown",
          "options":this.TherapeuticAreaList,
        },
        {
          "label": "Study Type",
          "field": "StudyType",
          "type": "dropdown",
          "options": this.studyType,
        },
        {
          "label": "Request Type",
          "field": "RequestType",
          "type": "dropdown",
          "options": this.requestType,
        },
        {
          "label": "Product",
          "field": "Product",
          "type": "dropdown",
          "options": this.productList,
        },
        {
          "label": "Status",
          "field": "status",
          "type": "dropdown",
          "options": this.StatusList,
        }
      ],
      "filters": [
        {
          "label": "New Applications in last one week",
          "filter_key": "unique_key_1",
          "criteria": ""
        },
        {
          "label": "New Applicaitons in last one month",
          "filter_key": "unique_key_2",
          "criteria": ""
        },
        {
          "label": "New Applications in last one quarter",
          "filter_key": "unique_key_3",
          "criteria": ""
        },
        {
          "label": "New Applications in last one year",
          "filter_key": "unique_key_4",
          "criteria": ""
        }
      ]
    };


    this.caseDetails= [
    {
      "caseSet" : {
        "caseHeading": "General",
          "caseData" : [
            {
              "label": "Application ID",
              "value": "APPLICATION_CODE"
            },
            {
              "label": "Physician Name",
              "value": "PhysicianName"
            },
            /* {
              "label": "Study Team members",
              "value": "StudyTeamMembers"
            }, */
            {
              "label": "Study Sponsored",
              "value": "StudySponceredBy"
            },
            {
              "label": "Therapeutic Area",
              "value": "THERAPEUTIC_AREA_NAME"
            },
            {
              "label": "Request Type",
              "value": "REQUEST_TYPE_NAME"
            },
            {
              "label": "Product",
              "value": "PRODUCT_NAME"
            },
            {
              "label": "Study Type",
              "value": "StudyType"
            },
            {
              "label": "Status",
              "value": "STATUSStr"
            },
            {
              "label": "Submitted On",
              "value": "SubmittedOnStr"
            },
            {
              "label": "Last Updated On",
              "value": "LastUpdatedStr"
            },
            {
              "label": "IRB Name",
              "value": "IRBName"
            },
            {
              "label": "#Total Requests",
              "value": "totalRequests"
            },
            {
              "label": "#Closed Requests",
              "value": "closedRequests"
            }
          ]

      }
    }
];
 
    this.getSummaryData();
    this. GetStatusList();

  }

  GetStatusList() {
    
    this.summaryService.masterData("api/gmapp/getstatus/2").subscribe(result => {
      if (result != null) {
        this.StatusList = result;
        this.StatusList=  [{label:"Select",value:"-1", checked: true}].concat(this.StatusList);

      }
    });
  }

  getSummaryData() {
    this.SearchClear();
    this.summaryService.getApplicationSummary("api/ISTGeneralInfo/GetApplicationsList").subscribe(summary => {debugger;
      this.rowData = summary["SummaryData"];
      this.studyType = summary["MasterDrops"].MasterData1;
      this.studyType = [{label:"Select",value:"",checked: true}].concat(this.studyType);
      this.TherapeuticAreaList = summary["MasterDrops"].MasterData2;
      this.TherapeuticAreaList=  [{label:"All",value:"", checked: true}].concat(this.TherapeuticAreaList);
      this.productList = summary["MasterDrops"].MasterData3;
      this.productList = [{label:"Select",value:"",checked: true}].concat(this.productList);
      this.requestType= summary["MasterDrops"].MasterData4;
      this.requestType = [{ label: "Select", value: "", checked: true }].concat(this.requestType);
    });
  }
  getSummarySearch(searchObject: any) {
    this.summaryService.getISTSearchSummary("api/ISTGeneralInfo/getSummarySearch", searchObject).subscribe(summary => {
      this.rowData = summary["SummaryData"];
    });
  }

  onAdvanceSearchOperation(searchFiletrs) {
    switch (searchFiletrs["OperationType"]) {
      case "viewall":
        this.SearchClear();
        this.getSummaryData();
        break;
      case "search":
        var searchObject = new Object();
        searchObject["Name"] = searchFiletrs["Name"];
        searchObject["ProductName"] = searchFiletrs["Product"];
        this.getSummarySearch(searchObject);
        break;
    }
  }
  onSetGridApi(gridApi){
    this.gridApi = gridApi;
  }
  onCallbackOperation(opr){
    opr.callback();
  }

  requestTypeChange(event) {
     ;
   let requestType= event.value;
   if (requestType != 1){ this.isProduct = false}
   else {this.isProduct = true}
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows()?this.gridApi.getSelectedRows()[0]:null;
  }

   onRowDoubleClicked(event) {
    this.commonService.removeLeftMenu();
    this.commonService.appId = event.data["ID"];
    this.summaryService.getISTApplicationSummary("api/common/getistapp/" + event.data["ID"]).subscribe(data => {
      this.commonService.removeLeftMenu();
      this.commonService.appId = data.ID;
      this.commonService.ScreenID = data.ID;
      this.istapp = data;
      this.commonService.setISTApp(this.istapp);
      this.menudata = new ModuleMenu();
      this.menudata.module = "IST";
      this.menudata.operation = "Edit";
      this.menudata.appId = this.istapp.ID;
      this.menudata.screenID = this.istapp.ID;
      this.menudata.tagetFrom="all";
      if (this.istapp.STATUS === null)
        this.menudata.formstate = "Draft";
      else
        this.menudata.formstate =this.istapp.CurrentStatusExt;//this.commonService.getStatus(this.istapp.STATUS);
      this.commonService.setModluleMenu(this.menudata);
      this.header.setHeader(this.menudata);
    });
    this.dataShare.setApplicationID(event.data["ID"]);
    this.router.navigate(['/home/ist/applications/application-ext/:' + event.data['ID'] + '/general_information_request'], { skipLocationChange: true, queryParams: { id: event.data['ID'], app_ext: true, module: "ist",submodule:"ist", screen_type: "applications" } })
    // let url = location.href.split('/');
    // window.open(url[0]+'//'+url[2]+'/home/ist/applications/application-ext/:'+this.selectedRow['id']+'/general_information_request');
  } 

 /*  getStatus(statusnum: number): string {
    let status = "";
    switch (statusnum) {
      case 0:
        status = "Draft";
        break;
      case 1:
        status = "Draft";
        break;
      case 2:
        status = "Submitted";
        break;
      case 3:
        status = "Review Ongoing";
        break;
      case 4:
        status = "Accepted";
        break;
      case 5:
        status = "Closed";
        break;
      case 6:
        status = "Reject";
        break;
      case 7:
        status = "Onhold";
        break;
      case 8:
        status = "Withdrawn";
        break;
      case 9:
        status = "Discard";
        break;
      case 10:
        status = "Assign";
        break;
    }
    return status;
  } */

  assign() {
    let users = [
      { value: '1', label: 'James Johnson' },
      { value: '2', label: 'Maria Rodriguez' },
      { value: '3', label: 'David Hernandez' },
      { value: '4', label: 'Micheal Smith' },
      { value: '5', label: 'John Williams' },
      { value: '6', label: 'Clara Clark' },
      { value: '7', label: 'Tony Taylor' },
      { value: '8', label: 'Henry Davis' },
    ]
    const modalRef = this.modalService.open(AssignDialogComponent,
      {
        windowClass: 'modal-md modal-full-height modal-right',
      });
      modalRef.componentInstance.Content={
        content: { users: users }
      }
  }
  
  routeModal() {
      this['self'].modalService.open(RouteComponent,{windowClass: 'modal-md modal-full-height modal-right'});
  }

  reject() {
    // let modalRef = this['self'].modalService.open(RejectComponent, {
    //   backdrop: false,
    //   keyboard: false,
    //   windowClass: 'modal-md modal-full-height modal-right',
    //   animation: true
    // });
    // modalRef.componentInstance.Content= {
    //   heading: 'Reject',
    //   content: null
    // }
  }

  onHold() {
    // let modalRef = this.modalService.open(RejectComponent, {
    //   backdrop: false,
    //   keyboard: false,
    //   windowClass: 'modal-md modal-full-height modal-right',
    //   animation: true
    // });
    // modalRef.componentInstance.Content={
    //   heading: 'On-Hold',
    //   content: null
    // }
  }

  submitfromDate(event){
    this.Submit_from_date = {
      Day : event.getDate(),
      Month : event.getMonth()+1,
      Year : event.getFullYear(),
      Hours : 0,
      Minutes : 0,
      Seconds : 0,
      HasValue : true

    };
  }
  submitendDate(event){
    this.Submit_end_date = {
      Day : event.getDate(),
      Month : event.getMonth()+1,
      Year : event.getFullYear(),
      Hours : 23,
      Minutes : 59,
      Seconds : 59,
      HasValue : true

    }

  }

  Submit_from_date : DateObject;
Submit_end_date : DateObject;

  //// Advace search Functions
  SearchClear() {
    this.IStApplicationsSearch.reset();
  }
  AdvanceSearch() {
    var formData = this.IStApplicationsSearch.value;
    formData["ApplicationID"] = "";
    /* if (formData["StartDate"] != null && formData["StartDate"] != undefined) {
      formData["StartDate"] = new Date(formData["StartDate"]);
    }
    if (formData["EndDate"] != null && formData["EndDate"] != undefined) {
      formData["EndDate"] = new Date(formData["EndDate"]);
    } */
    if (formData["StartDate"] != null && formData["StartDate"] != undefined && formData["StartDate"] != 'Invalid Date') 
    {
      //formData["StartDate"] = new Date(formData["StartDate"]);
      formData["StartDateO"] = this.Submit_from_date; 
    }
    if (formData["EndDate"] != null && formData["EndDate"] != undefined && formData["EndDate"] != 'Invalid Date') {
      
     // formData["EndDate"] = new Date(formData["EndDate"]);
      formData["EndDateO"] = this.Submit_end_date;
    }
    this.getSummarySearch(formData);
  }
}
    





